import { Component } from "react";
import { NSBox, NSDialog, NSLabel } from "namirasoft-site-react";
import { FormulaRow, CalculationResult, CostData } from "namirasoft-bill-watch";
import CalculationResultView from "./CalculationResultView";

export interface BatchSimulationLineProps 
{
	name: string;
	data: CostData[];
	value: CostData;
	formula: FormulaRow;
	result: CalculationResult;
}

export interface BatchSimulationLineState
{
	show_result: boolean;
}

export default class BatchSimulationLine extends Component<BatchSimulationLineProps, BatchSimulationLineState>
{
	constructor(props: BatchSimulationLineProps)
	{
		super(props);
		this.state = { show_result: false };
	}
	override render()
	{
		return (
			<>
				<div
					style={{
						width: NSBox.width.one,
						cursor: "pointer",
						border: "1px solid black",
						borderRadius: "8px"
					}}
					onClick={() =>
					{
						this.setState({ show_result: true });
					}}
				>
					<NSLabel
						title={this.props.name}
					>
						<span
							style={{ color: "black" }}
						>{`Data Length: ${this.props.data.length}`}
						</span>
						<br />
						<span
							style={{ color: "black" }}
						>{`Value: ${this.props.value.amount} ${this.props.value.unit}`}
						</span>
						<br />
						<span
							style={{ color: (this.props.result.value === true ? ("red") : (this.props.result.value === false ? "green" : "grey")), fontWeight: "bold" }}
						>{`Result: ${this.props.result.value === true ? ("Detected") : (this.props.result.value === false ? "Normal" : "Skipped")}`}
						</span>
					</NSLabel>
				</div>
				{
					this.state.show_result &&
					<NSDialog
						onClose={() =>
						{
							this.setState({ show_result: false });
						}}
						center_dialog
					>
						<CalculationResultView
							{...this.props}
						></CalculationResultView>
					</NSDialog>
				}
			</>
		);
	}
}